<template>
  <div class="MoodSelector">
    <div class="input">

      <select v-model="mood">
        <option v-for="moodIt in this.moods" :key="moodIt">
          {{moodIt}}
        </option>
      </select>

    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'MoodSelector',
  components: {
    //Component
  },
  data: function () {
    return {
      moods: ['🙂 Neutral','🙁 I feel bad','😍 I love it','😲 Wow!','✋ I have a question','☕ I need a break','👋 I need to go'],
    }
  },
  props: {
  },
  computed: {
    ...mapState([
      'languages',
    ]),
    mood: {
      get () { return this.$store.state.user.mood},
      set (value) {
        this.$store.dispatch('user/setMood', {mood: value, emit: true})
      }
    },
  },
  methods: {
    updateMood: function (){
      //this.$store.commit('user/setMood', {name: value})
      //this.$socket.emit('user update mood', value)
    },
  },
  mounted: function () {
    this.$store.dispatch('user/setMood', {mood: this.moods[0]})
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.MoodSelector{
}

.emojis{
  display: flex;
  flex-wrap: wrap;
}

.emoji{
  cursor: pointer;
  filter: grayscale(1);
}

.emoji.selected, .emoji:hover{
  filter: grayscale(0);
}

</style>
